export interface AdminBreadcrumb {
  label: string;
  path: string;
}

const BREADCRUMB_MAP: Readonly<Record<string, string>> = {
  dashboard: 'nav.dashboard',
  finance: 'nav.platformWallet',
  reports: 'nav.reports',
  reviews: 'nav.reviews',
  items: 'nav.peeks',
  messages: 'nav.messaging',
  users: 'nav.users',
  shops: 'nav.shops',
  'seller-requests': 'nav.sellerRequests',
  'product-requests': 'nav.productRequests',
  'buyer-strikes': 'nav.buyerStrikes',
  'seller-debts': 'nav.sellerDebts',
  orders: 'nav.orders',
  'pdp-reviews': 'nav.pdpSubmissionReviews',
  'missing-invoices': 'nav.missingInvoices',
  lives: 'nav.lives',
  discounts: 'nav.discounts',
  'referral-campaigns': 'nav.referralCampaigns',
  categories: 'nav.categories',
  'delivery-carriers': 'nav.deliveryCarriers',
  'shipping-rates': 'nav.shippingRates',
  search: 'nav.search',
  reconciliation: 'nav.reconciliation',
  queues: 'nav.queues',
  'admin-actions': 'nav.adminActions',
  nodes: 'nav.nodes',
  infra: 'nav.infrastructure',
  system: 'nav.systemHealth',
  'launch-status': 'nav.launchStatus',
  emails: 'nav.emails',
  support: 'nav.support',
  'tcg-reference': 'nav.referenceTcg',
  settings: 'nav.settings',
};

export function buildAdminBreadcrumbs(url: string): AdminBreadcrumb[] {
  const path = url.split(/[?#]/, 1)[0] ?? '';
  const segments = path.split('/').filter(Boolean);
  let accumulated = '';

  return segments.map(segment => {
    accumulated += `/${segment}`;
    return {
      label: BREADCRUMB_MAP[segment] ?? shortenDynamicSegment(segment),
      path: accumulated,
    };
  });
}

function shortenDynamicSegment(segment: string): string {
  return segment.length > 8 ? `${segment.substring(0, 8)}...` : segment;
}
